module.exports = __webpack_public_path__ + "src/assets/img/motor.e5ddb3cc.jpg";